var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 31.586 31.586",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.328 2.255H2.256A2.255 2.255 0 0 0 0 4.51v22.564a2.257 2.257 0 0 0 2.256 2.256h27.072a2.26 2.26 0 0 0 2.258-2.256V4.51a2.258 2.258 0 0 0-2.258-2.255zM7.333 3.949a1.127 1.127 0 1 1 0 2.253 1.126 1.126 0 1 1 0-2.253zm-3.386 0c.623 0 1.127.502 1.127 1.128 0 .623-.504 1.125-1.127 1.125a1.126 1.126 0 1 1 0-2.253zm25.381 23.126H2.256V7.92h27.072v19.155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.645 12.556 5.4 9.243v1.597l5.603 2.395v.031L5.4 15.66v1.596l7.245-3.313zM16.056 12.488h3.946v1.522h-3.946z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOs);
export default __webpack_public_path__ + "static/media/os.1689f993c42f12c917e4cf0531312b46.svg";
export { ForwardRef as ReactComponent };